export const fmt = (n: number | null | undefined, d = 0) =>
  n == null || !isFinite(n) ? "–" : n.toLocaleString("fr-FR", { minimumFractionDigits: d, maximumFractionDigits: d });

export const pct = (n: number | null | undefined) => (n == null || !isFinite(n) ? "–" : `${Math.round(n * 100)} %`);

export const dateTime = (s: string | null | undefined) =>
  s ? new Date(s).toLocaleString("fr-FR", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "–";

export const duration = (ms: number | null | undefined) => {
  if (ms == null) return "–";
  if (ms < 1000) return `${ms} ms`;
  const s = ms / 1000;
  if (s < 90) return `${fmt(s, 1)} s`;
  const m = Math.floor(s / 60);
  return m < 90 ? `${m} min ${Math.round(s % 60)} s` : `${Math.floor(m / 60)} h ${m % 60} min`;
};

export const bytes = (n: number | null | undefined) => {
  if (n == null) return "–";
  const u = ["o", "Ko", "Mo", "Go"];
  let i = 0;
  let v = n;
  while (v >= 1024 && i < u.length - 1) {
    v /= 1024;
    i++;
  }
  return `${fmt(v, i ? 1 : 0)} ${u[i]}`;
};

/** SIRET lisible : 123 456 782 00010 */
export const siret = (s: string | null | undefined) =>
  !s ? "–" : s.length === 14 ? `${s.slice(0, 3)} ${s.slice(3, 6)} ${s.slice(6, 9)} ${s.slice(9)}` : s;

export const plural = (n: number, one: string, many?: string) => (n > 1 ? many ?? `${one}s` : one);

export function display(v: unknown): string {
  if (v == null || v === "") return "–";
  if (Array.isArray(v)) return v.length ? v.join(", ") : "–";
  if (typeof v === "number") return fmt(v, Number.isInteger(v) ? 0 : 2);
  if (typeof v === "boolean") return v ? "Oui" : "Non";
  if (typeof v === "string" && /^\d{4}-\d{2}-\d{2}$/.test(v)) return new Date(v + "T12:00").toLocaleDateString("fr-FR");
  return String(v);
}
